'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WarningAlertIcon = function WarningAlertIcon(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement('path', { fill: fill, fillRule: 'evenodd', d: 'M15 16H1a1.001 1.001 0 0 1-.895-1.448l7-14c.34-.678 1.449-.678 1.789 0l7 14A1 1 0 0 1 15 16zM7 6h2v4H7V6zm1 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-5.382 1h10.764L8 3.236 2.618 14z' })
    )
  );
};

WarningAlertIcon.propTypes = _extends({}, _Icon2.default.propTypes);

WarningAlertIcon.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  size: 'small',
  fill: _theme2.default.colors.warning
});

exports.default = WarningAlertIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1dhcm5pbmdBbGVydEljb24uanMiXSwibmFtZXMiOlsiV2FybmluZ0FsZXJ0SWNvbiIsImZpbGwiLCJwcm9wcyIsImRpc3BsYXkiLCJwcm9wVHlwZXMiLCJkZWZhdWx0UHJvcHMiLCJzaXplIiwiY29sb3JzIiwid2FybmluZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTUEsbUJBQW1CLFNBQW5CQSxnQkFBbUIsT0FBd0I7QUFBQSxNQUFyQkMsSUFBcUIsUUFBckJBLElBQXFCO0FBQUEsTUFBWkMsS0FBWTs7QUFDL0MsU0FDRTtBQUFBO0FBQVVBLFNBQVY7QUFDRTtBQUFBO0FBQUEsUUFBSyxPQUFPLEVBQUVDLFNBQVMsT0FBWCxFQUFaLEVBQWtDLE9BQU0sTUFBeEMsRUFBK0MsUUFBTyxNQUF0RCxFQUE2RCxTQUFRLFdBQXJFO0FBQ0UsOENBQU0sTUFBTUYsSUFBWixFQUFrQixVQUFTLFNBQTNCLEVBQXFDLEdBQUUsOEtBQXZDO0FBREY7QUFERixHQURGO0FBT0QsQ0FSRDs7QUFVQUQsaUJBQWlCSSxTQUFqQixnQkFDSyxlQUFLQSxTQURWOztBQUlBSixpQkFBaUJLLFlBQWpCLGdCQUNLLGVBQUtBLFlBRFY7QUFFRUMsUUFBTSxPQUZSO0FBR0VMLFFBQU0sZ0JBQU1NLE1BQU4sQ0FBYUM7QUFIckI7O2tCQU1lUixnQiIsImZpbGUiOiJXYXJuaW5nQWxlcnRJY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJ1xuaW1wb3J0IHRoZW1lIGZyb20gJy4vdGhlbWUnXG5cbmNvbnN0IFdhcm5pbmdBbGVydEljb24gPSAoeyBmaWxsLCAuLi5wcm9wcyB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPEljb24gey4uLnByb3BzfT5cbiAgICAgIDxzdmcgc3R5bGU9e3sgZGlzcGxheTogJ2Jsb2NrJyB9fSB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJyB2aWV3Qm94PScwIDAgMTYgMTYnPlxuICAgICAgICA8cGF0aCBmaWxsPXtmaWxsfSBmaWxsUnVsZT0nZXZlbm9kZCcgZD0nTTE1IDE2SDFhMS4wMDEgMS4wMDEgMCAwIDEtLjg5NS0xLjQ0OGw3LTE0Yy4zNC0uNjc4IDEuNDQ5LS42NzggMS43ODkgMGw3IDE0QTEgMSAwIDAgMSAxNSAxNnpNNyA2aDJ2NEg3VjZ6bTEgN2ExIDEgMCAxIDEgMC0yIDEgMSAwIDAgMSAwIDJ6bS01LjM4MiAxaDEwLjc2NEw4IDMuMjM2IDIuNjE4IDE0eicgLz5cbiAgICAgIDwvc3ZnPlxuICAgIDwvSWNvbj5cbiAgKVxufVxuXG5XYXJuaW5nQWxlcnRJY29uLnByb3BUeXBlcyA9IHtcbiAgLi4uSWNvbi5wcm9wVHlwZXNcbn1cblxuV2FybmluZ0FsZXJ0SWNvbi5kZWZhdWx0UHJvcHMgPSB7XG4gIC4uLkljb24uZGVmYXVsdFByb3BzLFxuICBzaXplOiAnc21hbGwnLFxuICBmaWxsOiB0aGVtZS5jb2xvcnMud2FybmluZ1xufVxuXG5leHBvcnQgZGVmYXVsdCBXYXJuaW5nQWxlcnRJY29uXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/WarningAlertIcon.js
// module id = 592
// module chunks = 0